const __WEBPACK_NAMESPACE_OBJECT__ = window["wp"]["richText"];